<template>
  <v-dialog class="edit-issue-popup"
            :value="visiblePopup"
            fullscreen
            @click:outside="onCloseClickButton"
            @keydown.esc="onCloseClickButton">
    <v-card class="popup-wrapper">
      <issue-add-edit-popup-core-content
        :currentIssue="issueDetails"
        :title="'issueDataPopup.editIssue'"
        @closed="onCloseClickButton"
        @saved="save"/>
    </v-card>
  </v-dialog>

</template>

<script>

import { mapGetters } from 'vuex';

import { EDIT_ISSUE } from '@/store/issue/actionTypes';
import IssueAddEditPopupCoreContent from '@/components/issue/IssueAddEditPopupCoreContent.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'EditIssuePopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: { IssueAddEditPopupCoreContent },
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    projectId: null,
  },
  computed: {
    ...mapGetters(['profile', 'issueDetails']),
  },
  methods: {
    onCloseClickButton() {
      this.$emit('closed');
    },
    async save(resultIssue) {
      const issue = resultIssue;
      issue.serviceProviderWorkerId = this.profile.id;
      const options = { projectId: this.projectId, issueId: issue.id, issue };
      await this.$store.dispatch(EDIT_ISSUE, options);
      this.$emit('saved');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
